import getDomain from '../domian'
import {TestApi} from '../domainConfig'
import http from '../http'

const domain = getDomain(TestApi)

const Api = {
    // 权限
    refreshToken(data) {
        return http.post('/adminapi/admin/refreshToken', data, domain)
    },
    // 权限
    getUserRole(data) {
        return http.post('/adminapi/admin/role', data, domain)
    },
    // 分类
    classifyList(data) {
        return http.post('/adminapi/course/classify/list', data, domain)
    },
    // 列表
    courseList(data) {
        return http.post('/adminapi/course/list', data, domain)
    },
    // 创建
    courseCreate(data) {
        return http.post('/adminapi/course/create', data, domain)
    },
    // 更新
    courseModify(data) {
        return http.post('/adminapi/course/modify', data, domain)
    },
    // 删除
    courseRemove(data) {
        return http.post('/adminapi/course/remove', data, domain)
    },
    // 详情
    courseDetail(data) {
        return http.post('/adminapi/course/detail', data, domain)
    },
    // 上下架
    courseStatus(data) {
        return http.post('/adminapi/course/status', data, domain)
    },
    // 列表
    buyList(data) {
        return http.post('/adminapi/buy/list', data, domain)
    },
    // 列表
    buyListBySeller(data) {
        return http.post('/adminapi/buy/listBySeller', data, domain)
    },
    // 详情
    buyDetail(data) {
        return http.post('/adminapi/buy/detail', data, domain)
    },
    // 修改
    buyModify(data) {
        return http.post('/adminapi/buy/modify', data, domain)
    },
    // 退款确认
    refundApply(data) {
        return http.post('/adminapi/buy/refund/apply', data, domain)
    },
    // 退款确认
    refundApprove(data) {
        return http.post('/adminapi/buy/refund/approve', data, domain)
    },
    // 退款拒绝
    refundReject(data) {
        return http.post('/adminapi/buy/refund/reject', data, domain)
    },
    // 详情
    breakruleDetail(data) {
        return http.post('/adminapi/breakrule/detail', data, domain)
    },
    // 列表
    userList(data) {
        return http.post('/adminapi/user/list', data, domain)
    },
    // 状态
    userStatus(data) {
        return http.post('/adminapi/user/status', data, domain)
    },
    // 级别
    userLevel(data) {
        return http.post('/adminapi/user/level', data, domain)
    },
    // 详情
    userDetail(data) {
        return http.post('/adminapi/user/detail', data, domain)
    },
    // 退款申请
    userRefundApply(data) {
        return http.post('/adminapi/user/refund/apply', data, domain)
    },
    // 退款成功
    userRefundSuccess(data) {
        return http.post('/adminapi/user/refund/success', data, domain)
    },
    // 通知发送
    userNoticeSend(data) {
        return http.post('/adminapi/user/notice/send', data, domain)
    },
    // 意见列表
    userSuggestList(data) {
        return http.post('/adminapi/user/suggest/list', data, domain)
    },
    // 意见列表
    userSuggestDetail(data) {
        return http.post('/adminapi/user/suggest/detail', data, domain)
    },
    // 意见反馈
    userSuggestReply(data) {
        return http.post('/adminapi/user/suggest/reply', data, domain)
    },
    // 意见删除
    userSuggestRemove(data) {
        return http.post('/adminapi/user/suggest/remove', data, domain)
    },
    // 提现
    cashListBySeller(data) {
        return http.post('/adminapi/user/cash/list', data, domain)
    },
    // 设置修改
    settingDetail(data) {
        return http.post('/adminapi/system/setting/detail', data, domain)
    },
    // 设置修改
    settingModify(data) {
        return http.post('/adminapi/system/setting/modify', data, domain)
    },
    //文件上传
    uploadFile(params) {
        return http.post('/adminapi/file/upload', null, domain, null, params)
    },
    //密码修改
    password(data) {
        return http.post('/adminapi/admin/password', data, domain)
    }
}
export default Api;